import {
  confirmResetPassword,
  confirmSignIn,
  confirmUserAttribute,
  fetchAuthSession as _fetchAuthSession,
  fetchDevices,
  forgetDevice,
  rememberDevice,
  resetPassword,
  sendUserAttributeVerificationCode,
  setUpTOTP,
  signIn,
  signInWithRedirect,
  signOut,
  updateMFAPreference,
  fetchMFAPreference,
  updatePassword,
  verifyTOTPSetup,
} from 'aws-amplify/auth';

import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';

export const setClientMetadataResolver = (clientMetadata) => cognitoUserPoolsTokenProvider.setClientMetadataProvider(() => clientMetadata);

export const currentAuthenticatedUser = async (options) => {
  const user = await fetchAuthSession(options);
  if (!user.credentials) throw 'Authentication error';
  const currentAuthenticatedUser = {
    signInUserSession: user,
    attributes: user?.idToken?.payload || user?.tokens?.idToken?.payload
  };
  currentAuthenticatedUser.attributes.sso = currentAuthenticatedUser.attributes.identities?.some(identity => identity.providerType === 'SAML' && (identity.primary === true || identity.primary === 'true'));

  return currentAuthenticatedUser;
};

export const getAWSCredentials = async (options) => {
  const user = await fetchAuthSession(options);
  return user.credentials;
};

export const fetchAuthSession = async (options) => {
  const session = await _fetchAuthSession(options);

  const toLegacyToken = (token) => token ? ({
    ...token,
    jwtToken: token.toString(),
    getJwtToken: () => token.toString(),
    decodePayload: () => token.payload
  }) : undefined;

  const idToken = toLegacyToken(session.tokens?.idToken);
  const accessToken = toLegacyToken(session.tokens?.accessToken);
  const refreshToken = session.tokens?.refreshToken ? {
    ...session.tokens.refreshToken,
    token: session.tokens.refreshToken.toString(),
    getToken: () => session.tokens.refreshToken.toString()
  } : undefined;

  return {
    ...session,
    tokens: {
      ...session.tokens,
      idToken,
      accessToken,
      refreshToken
    },
    idToken,
    accessToken,
    refreshToken,
    getIdToken: () => idToken,
    getAccessToken: () => accessToken,
    getRefreshToken: () => refreshToken
  };
};

export const getCachedDeviceCredentials = (sessionOrUser) => {
  const session = sessionOrUser?.signInUserSession || sessionOrUser;
  const accessPayload = session?.accessToken?.payload;
  const idPayload = session?.idToken?.payload;
  const clientId = accessPayload?.client_id || idPayload?.aud;
  const username = idPayload?.['cognito:username'] || accessPayload?.username;

  if (!clientId || !username || typeof localStorage === 'undefined') {
    return { deviceKey: undefined, deviceGroupKey: undefined, randomPassword: undefined };
  }

  const keyPrefix = `CognitoIdentityServiceProvider.${clientId}.${username}`;
  return {
    deviceKey: localStorage.getItem(`${keyPrefix}.deviceKey`) || undefined,
    deviceGroupKey: localStorage.getItem(`${keyPrefix}.deviceGroupKey`) || undefined,
    randomPassword: localStorage.getItem(`${keyPrefix}.randomPasswordKey`) || undefined,
    refreshToken: localStorage.getItem(`${keyPrefix}.refreshToken`) || undefined
  };
};

export async function getIdentityId () {
  const credentials = await fetchAuthSession();
  return credentials.identityId;
}

export {
  signOut,
  sendUserAttributeVerificationCode,
  confirmUserAttribute,
  fetchDevices,
  setUpTOTP,
  updateMFAPreference,
  forgetDevice,
  verifyTOTPSetup,
  updatePassword,
  fetchMFAPreference,
  resetPassword,
  confirmResetPassword,
  signInWithRedirect,
  confirmSignIn,
  rememberDevice,
  signIn,
};


